<template>
  <multi-select :options="options"
    :selected-options="items"
    v-model="value"
    @searchchange="search"
    :placeholder="schema.placeholder"
    @select="onSelect"
  >
  </multi-select>
</template>

<script>
import { MultiSelect } from 'vue-search-select';
import { abstractField } from 'vue-form-generator';

const axios = require('axios');

export default {
  components: {
    MultiSelect,
  },
  mixins: [abstractField],
  data() {
    return {
      options: [],
      items: [],
      lastSelectItem: {},
    };
  },
  methods: {
    search() {
      axios.get(this.schema.url)
        .then((response) => {
          this.options = response.data;
        })
        .catch(() => []);
    },
    onSelect(items, lastSelectItem) {
      this.items = items;
      this.value = items;
      this.lastSelectItem = lastSelectItem;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/custom_fields/general/fieldSearchMultiSelect.vue